import { render } from "./HousesList.vue?vue&type=template&id=6cfa287c&scoped=true"
import script from "./HousesList.vue?vue&type=script&lang=js"
export * from "./HousesList.vue?vue&type=script&lang=js"

import "./HousesList.vue?vue&type=style&index=0&id=6cfa287c&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfa287c"]])

export default __exports__